import dynamic from 'next/dynamic';

export type IconComponent =
  | React.ComponentType<React.SVGProps<SVGSVGElement>>
  | undefined;

export const UpArrowIcon = dynamic(
  () => import('./icon-chevron-up.svg')
) as IconComponent;
export const SustainabilityRectangle = dynamic(
  () => import('./sustainability-rectangle.svg')
) as IconComponent;

export const ProfileReservation = dynamic(
  () => import('./profile-reservation.svg')
) as IconComponent;

export const DownArrowIcon = dynamic(
  () => import('./icon-chevron-down.svg')
) as IconComponent;

export const WarningIcon = dynamic(
  () => import('./icon-warning.svg')
) as IconComponent;
export const SkipassIcon = dynamic(
  () => import('./skipass.svg')
) as IconComponent;

export const HotelIcon = dynamic(() => import('./hotel.svg')) as IconComponent;

export const VisaCardIcon = dynamic(
  () => import('./visa.svg')
) as IconComponent;

export const AmexCardIcon = dynamic(
  () => import('./amex.svg')
) as IconComponent;

export const LocationIcon = dynamic(
  () => import('./location-pin.svg')
) as IconComponent;

export const PersonIcon = dynamic(
  () => import('./icon-person.svg')
) as IconComponent;

export const CalendarIcon = dynamic(
  () => import('./icon-calendar.svg')
) as IconComponent;

export const DeleteIcon = dynamic(
  () => import('./delete.svg')
) as IconComponent;

export const PersonsIcon = dynamic(
  () => import('./persons-icon.svg')
) as IconComponent;

export const DontUser = dynamic(
  () => import('./dont-user.svg')
) as IconComponent;

export const Delete = dynamic(() => import('./dlt.svg')) as IconComponent;

export const PlusIcon = dynamic(() => import('./plus.svg')) as IconComponent;

export const InfoIcon = dynamic(() => import('./info.svg')) as IconComponent;

export const AlertIcon = dynamic(
  () => import('./icon-alert-circle-fill.svg')
) as IconComponent;

export const CloseIcon = dynamic(
  () => import('./icon-close.svg')
) as IconComponent;

export const SeturLogo = dynamic(
  () => import('./misc-setur-logo.svg')
) as IconComponent;

export const TrashIcon = dynamic(
  () => import('./icon-trash.svg')
) as IconComponent;

export const FilterIcon = dynamic(
  () => import('./icon-filter.svg')
) as IconComponent;

export const WorldLogo = dynamic(
  () => import('./world-card-logo.svg')
) as IconComponent;

export const CheckmarkIcon = dynamic(
  () => import('./checkmark-circle-2-outline.svg')
) as IconComponent;

export const ScrollIcon = dynamic(
  () => import('./scrollToTop.svg')
) as IconComponent;

export const SafeIcon = dynamic(
  () => import('./guvenli-otel.svg')
) as IconComponent;

export const EditIcon = dynamic(
  () => import('./icon-edit.svg')
) as IconComponent;

export const CheckedRedIcon = dynamic(
  () => import('./check-outline-icon.svg')
) as IconComponent;

export const CheckedWhiteIcon = dynamic(
  () => import('./check-icon-white.svg')
) as IconComponent;

export const BoxIconWhite = dynamic(
  () => import('./box-icon-white.svg')
) as IconComponent;

export const BoxIcon = dynamic(
  () => import('./box-icon-color.svg')
) as IconComponent;

export const BaseCheckIcon = dynamic(
  () => import('./icon-check-base.svg')
) as IconComponent;

export const NightIcon = dynamic(
  () => import('./icon-night.svg')
) as IconComponent;

export const FacebookIcon = dynamic(
  () => import('./facebook-blue.svg')
) as IconComponent;

export const HamburgerIcon = dynamic(
  () => import('./icon-hamburger.svg')
) as IconComponent;

export const HmgrIcon = dynamic(
  () => import('./hmgr-icon.svg')
) as IconComponent;

export const PhoneIcon = dynamic(
  () => import('./icon-phone.svg')
) as IconComponent;

export const TwitterIcon = dynamic(
  () => import('./twitter-blue.svg')
) as IconComponent;

export const BillIcon = dynamic(
  () => import('./icon-bill.svg')
) as IconComponent;

export const FacebookLogo = dynamic(
  () => import('./facebook.svg')
) as IconComponent;

export const InstagramLogo = dynamic(
  () => import('./instagram.svg')
) as IconComponent;

export const YoutubeLogo = dynamic(
  () => import('./youtube.svg')
) as IconComponent;

export const TwitterLogo = dynamic(
  () => import('./twitter.svg')
) as IconComponent;

export const PinterestLogo = dynamic(
  () => import('./pinterest.svg')
) as IconComponent;

export const WhatsappLogo = dynamic(
  () => import('./whatsapp.svg')
) as IconComponent;

export const RightArrowIcon = dynamic(
  () => import('./icon-arrow-right.svg')
) as IconComponent;

export const RadarIcon = dynamic(() => import('./radar.svg')) as IconComponent;

export const ChevronRight = dynamic(
  () => import('./icon-chevron-right.svg')
) as IconComponent;

export const OutlinkIcon = dynamic(
  () => import('./icon-outlink.svg')
) as IconComponent;

export const ShareIcon = dynamic(
  () => import('./icon-share.svg')
) as IconComponent;

export const DecrementIcon = dynamic(
  () => import('./icon-minus.svg')
) as IconComponent;

export const HopiIcon = dynamic(() => import('./hopi.svg')) as IconComponent;

export const TurkTelekomIcon = dynamic(
  () => import('./turk-telekom.svg')
) as IconComponent;

export const PlaneTakeOff = dynamic(
  () => import('./plane-takeoff.svg')
) as IconComponent;

export const PlaneLanding = dynamic(
  () => import('./plane-landing.svg')
) as IconComponent;

export const SquareCheck = dynamic(
  () => import('./icon-square-check.svg')
) as IconComponent;

export const ChevronLeft = dynamic(
  () => import('./icon-chevron-left.svg')
) as IconComponent;

export const LocationFilled = dynamic(
  () => import('./icon-location-fill.svg')
) as IconComponent;

export const ChevronUp = dynamic(() => import('./up.svg')) as IconComponent;

export const Setur = dynamic(() => import('./setur.svg')) as IconComponent;

export const Notes = dynamic(() => import('./icon-notes.svg')) as IconComponent;

export const LimitedOption = dynamic(
  () => import('./limited-option.svg')
) as IconComponent;

export const Available = dynamic(
  () => import('./icon-availability-available.svg')
) as IconComponent;

export const AvailableLimited = dynamic(
  () => import('./icon-availability-limited.svg')
) as IconComponent;

export const NotAvailable = dynamic(
  () => import('./icon-availability-not-available.svg')
) as IconComponent;

export const ExclamationCircleIcon = dynamic(
  () => import('./exclamation-circle.svg')
) as IconComponent;

export const TurkTelekomPrimeIcon = dynamic(
  () => import('./prime-logo.svg')
) as IconComponent;

export const CheckInIcon = dynamic(
  () => import('./check-in.svg')
) as IconComponent;

export const CheckOutIcon = dynamic(
  () => import('./check-out.svg')
) as IconComponent;

export const ChangeVertical = dynamic(
  () => import('./change-vertical.svg')
) as IconComponent;

export const StarIcon = dynamic(() => import('./star.svg')) as IconComponent;

export const PayIcon = dynamic(() => import('./pay.svg')) as IconComponent;

export const DurationIcon = dynamic(
  () => import('./icon-duration.svg')
) as IconComponent;

export const ChainIcon = dynamic(() => import('./chain.svg')) as IconComponent;

export const CarIcon = dynamic(() => import('./car.svg')) as IconComponent;

export const TransferIcon = dynamic(
  () => import('./transfer-icon.svg')
) as IconComponent;

export const HistoryIcon = dynamic(
  () => import('./icon-history.svg')
) as IconComponent;

export const FireIcon = dynamic(
  () => import('./icon-fire.svg')
) as IconComponent;

export const LuggageIcon = dynamic(
  () => import('./icon-luggage.svg')
) as IconComponent;

export const CruiseIcon = dynamic(
  () => import('./icon-cruise.svg')
) as IconComponent;

export const PlaneIcon = dynamic(
  () => import('./icon-plane.svg')
) as IconComponent;

export const ExitIcon = dynamic(
  () => import('./icon-exit.svg')
) as IconComponent;

export const SearchIcon = dynamic(
  () => import('./icon-search.svg')
) as IconComponent;

export const BussinessIcon = dynamic(
  () => import('./bussiness.svg')
) as IconComponent;
export const FamilyIcon = dynamic(
  () => import('./family.svg')
) as IconComponent;
export const FriendsIcon = dynamic(
  () => import('./friends.svg')
) as IconComponent;
export const ProfileIcon = dynamic(
  () => import('./profile.svg')
) as IconComponent;
export const NotificationIcon = dynamic(
  () => import('./icon-notifications.svg')
) as IconComponent;

export const FacebookDefault = dynamic(
  () => import('./facebook-default.svg')
) as IconComponent;

export const EyeIcon = dynamic(() => import('./icon-eye.svg')) as IconComponent;

export const EyeOffIcon = dynamic(
  () => import('./icon-eye-off.svg')
) as IconComponent;

export const CheckCircle = dynamic(
  () => import('./check-circle-regular.svg')
) as IconComponent;

export const MinibusIcon = dynamic(
  () => import('./icon-minibus.svg')
) as IconComponent;

export const ArrowDownIcon = dynamic(
  () => import('./icon-arrow-down.svg')
) as IconComponent;

export const CoinsIcon = dynamic(() => import('./coins.svg')) as IconComponent;

export const CreditCartIcon = dynamic(
  () => import('./icon-credit-card.svg')
) as IconComponent;

export const CreditCartIconMultiple = dynamic(
  () => import('./icon-credit-card-multiple.svg')
) as IconComponent;

export const GarantiPayIcon = dynamic(
  () => import('./garantipay.svg')
) as IconComponent;

export const InfoIconBlue = dynamic(
  () => import('./icon-info-blue.svg')
) as IconComponent;

export const ShipIcon = dynamic(() => import('./ship.svg')) as IconComponent;

export const NoReservationIcon = dynamic(
  () => import('./no-reservation.svg')
) as IconComponent;

export const Hand = dynamic(
  () => import('../images/webp/garantee')
) as IconComponent;

export const ChippinPayIcon = dynamic(
  () => import('./chippin-pay.svg')
) as IconComponent;

export const HopiPayIcon = dynamic(
  () => import('./hopi-pay.svg')
) as IconComponent;

export const ParoPayIcon = dynamic(
  () => import('./paro-pay.svg')
) as IconComponent;

export const SeturPayIcon = dynamic(
  () => import('./setur-pay.svg')
) as IconComponent;

export const WorldPayIcon = dynamic(
  () => import('./world-pay.svg')
) as IconComponent;

export const BusIcon = dynamic(() => import('./icon-bus.svg')) as IconComponent;

export const MailIcon = dynamic(
  () => import('./icon-mail.svg')
) as IconComponent;

export const ZubizuIcon = dynamic(
  () => import('./zubizu.svg')
) as IconComponent;

export const TTBusiness = dynamic(
  () => import('./tt-business.svg')
) as IconComponent;

export const BasketIcon = dynamic(
  () => import('./basket.svg')
) as IconComponent;

export const BasketDarkIcon = dynamic(
  () => import('./basket-dark.svg')
) as IconComponent;

export const TrainFilled = dynamic(
  () => import('./train-filled.svg')
) as IconComponent;

export const PhoneFill = dynamic(
  () => import('./phone-fill.svg')
) as IconComponent;

export const PhoneHeader = dynamic(
  () => import('./phoneHeader.svg')
) as IconComponent;

export const SignUp = dynamic(() => import('./signUp.svg')) as IconComponent;

export const UserLogin = dynamic(
  () => import('./userLogin.svg')
) as IconComponent;

export const BasketHeaderIcon = dynamic(
  () => import('./basketHeader.svg')
) as IconComponent;

export const AnnouncementIcon = dynamic(
  () => import('./announcement.svg')
) as IconComponent;

export const UnconditionalRefund = dynamic(
  () => import('./refund.svg')
) as IconComponent;

export const SecurePayment = dynamic(
  () => import('./secure-payment.svg')
) as IconComponent;

export const CustomerHappiness = dynamic(
  () => import('./customer-happiness.svg')
) as IconComponent;

export const PriceGuarantee = dynamic(
  () => import('./price-guarantee.svg')
) as IconComponent;

export const MastercardIcon = dynamic(
  () => import('./mastercard.svg')
) as IconComponent;

export const SeturSmall = dynamic(
  () => import('./setur_small.svg')
) as IconComponent;

export const HandshakeRegular = dynamic(
  () => import('./handshake-regular.svg')
) as IconComponent;

export const ClockIcon = dynamic(
  () => import('./icon-clock.svg')
) as IconComponent;

export const ArrowLeft = dynamic(
  () => import('./arrow-left.svg')
) as IconComponent;

export const CheckMark = dynamic(
  () => import('./check-mark.svg')
) as IconComponent;

export const HotelBuild = dynamic(
  () => import('./hotel-build.svg')
) as IconComponent;

export const ShipOutline = dynamic(
  () => import('./ship-outline.svg')
) as IconComponent;

export const MapPin = dynamic(() => import('./map-pin.svg')) as IconComponent;

export const PlaneListIcon = dynamic(
  () => import('./plane_icon.svg')
) as IconComponent;

export const CallCenterIcon = dynamic(
  () => import('./icon-callcenter.svg')
) as IconComponent;

export const FaxIcon = dynamic(() => import('./icon-fax.svg')) as IconComponent;

export const ChangePromotionIcon = dynamic(
  () => import('./change-icon.svg')
) as IconComponent;

export const SuitcaseIcon = dynamic(
  () => import('./icon-bavul.svg')
) as IconComponent;

export const Star = dynamic(() => import('./icon-star.svg')) as IconComponent;

export const InfoFillIcon = dynamic(
  () => import('./info-fill.svg')
) as IconComponent;

export const PrintIcon = dynamic(() => import('./print.svg')) as IconComponent;

export const IconKocAilem = dynamic(
  () => import('./icon-koc-ailem.svg')
) as IconComponent;

export const FullScreenIcon = dynamic(() => import('./fullscreen.svg'));
export const AccountSettings = dynamic(
  () => import('./account-settings.svg')
) as IconComponent;

export const DiscountClubs = dynamic(
  () => import('./discount-clubs.svg')
) as IconComponent;

export const PersonIconButton = dynamic(
  () => import('./person-icon.svg')
) as IconComponent;
export const SendPlane = dynamic(
  () => import('./sendPlane.svg')
) as IconComponent;
export const ExpressPayIcon = dynamic(
  () => import('./express-pay.svg')
) as IconComponent;

export const ExpressPayLogoIcon = dynamic(
  () => import('./express-pay-logo.svg')
) as IconComponent;

export const CardVirtual = dynamic(
  () => import('./card-virtual.svg')
) as IconComponent;

export const UserCoupons = dynamic(
  () => import('./user-coupons.svg')
) as IconComponent;

export const CreditCartOpportinity = dynamic(
  () => import('./credit-card-opportinity-card.svg')
) as IconComponent;

export const CopyLinkPopUpTick = dynamic(
  () => import('./copyLinkPopUpTick.svg')
) as IconComponent;

export const TourPlacesToGo = dynamic(
  () => import('./tourPlaceToGo.svg')
) as IconComponent;

export const TelegramIcon = dynamic(
  () => import('./icon-telegram.svg')
) as IconComponent;

export const EarnPoints = dynamic(
  () => import('./earn-points.svg')
) as IconComponent;

export const EarnPointsDark = dynamic(
  () => import('./earn-points-dark.svg')
) as IconComponent;
export const RentCarIcon = dynamic(
  () => import('./rentCarIcon.svg')
) as IconComponent;
export const NoDataIcon = dynamic(
  () => import('./no-data-icon.svg')
) as IconComponent;

export const RobotIcon = dynamic(() => import('./robot.svg')) as IconComponent;
export const sustainabilityIcon = dynamic(() => import('./sustainability.svg'));

export const PlayVideoBadgeIcon = dynamic(
  () => import('./play-video-badge.svg')
) as IconComponent;

export const PlayCircleIcon = dynamic(
  () => import('./play_icon.svg')
) as IconComponent;

export const PlayVideoModalIcon = dynamic(
  () => import('./play-video-modal.svg')
) as IconComponent;

export const HoursIcon = dynamic(
  () => import('./24-hours-line.svg')
) as IconComponent;

export const CustomerServiceIcon = dynamic(
  () => import('./customer-service-line.svg')
) as IconComponent;

export const FavoriteIcon = dynamic(
  () => import('./favoriteFilled.svg')
) as IconComponent;

export const FavoriteDeleteIcon = dynamic(
  () => import('./favorite.svg')
) as IconComponent;

export const NoFavoritesIcon = dynamic(() => import('./no-favorites.svg'));

export const StarSmile = dynamic(
  () => import('./star-smile.svg')
) as IconComponent;

export const CyprusFlightIcon = dynamic(
  () => import('./cyprus-flight.svg')
) as IconComponent;

export const LockedIcon = dynamic(
  () => import('./lock-lock-line.svg')
) as IconComponent;

export const UnlockedIcon = dynamic(
  () => import('./lock-unlock-line.svg')
) as IconComponent;

export const FlightPlusIcon = dynamic(
  () => import('./flight-plus-icon.svg')
) as IconComponent;

export const NewLuggageIcon = dynamic(
  () => import('./new-luggage.svg')
) as IconComponent;

export const CheckIcon = dynamic(() => import('./check.svg')) as IconComponent;

export const SummerIcon = dynamic(
  () => import('./Summer.svg')
) as IconComponent;
export const WinterIcon = dynamic(
  () => import('./Winter.svg')
) as IconComponent;
export const TripAdvisor = dynamic(
  () => import('./trip_advisor.svg')
) as IconComponent;

export const MailNext = dynamic(
  () => import('./mail-next.svg')
) as IconComponent;

export const TelegramNext = dynamic(
  () => import('./telegram-next.svg')
) as IconComponent;

export const TwitterNext = dynamic(
  () => import('./twitter-next.svg')
) as IconComponent;

export const FacebookNext = dynamic(
  () => import('./facebook-next.svg')
) as IconComponent;

export const WhatsappNext = dynamic(
  () => import('./whatsapp-next.svg')
) as IconComponent;

export const SustainabilityIconNext = dynamic(
  () => import('./sustainability-item-2.svg')
) as IconComponent;

export const SkipassIconNext = dynamic(
  () => import('./skipass-next.svg')
) as IconComponent;

export const AirportTransferNext = dynamic(
  () => import('./airport-transfer.svg')
) as IconComponent;

export const FeatureBullet = dynamic(
  () => import('./FeatureBullet.svg')
) as IconComponent;

export const FilterIconNext = dynamic(
  () => import('./filter-icon.svg')
) as IconComponent;

export const FillFireIcon = dynamic(
  () => import('./fire.svg')
) as IconComponent;

export const EditIconNext = dynamic(
  () => import('./edit-icon.svg')
) as IconComponent;

export const ContinueToPaymentIcon = dynamic(
  () => import('./continue-to-payment-icon.svg')
) as IconComponent;

export const LimitIcon = dynamic(
  () => import('./limit-icon.svg')
) as IconComponent;

export const EventCalendarIcon = dynamic(
  () => import('./event-calendar.svg')
) as IconComponent;

export const MapLocationPinIcon = dynamic(
  () => import('./map-location-pin.svg')
) as IconComponent;

export const NotFoundListingSearch = dynamic(
  () => import('./not-found-search-icon.svg')
) as IconComponent;

export const DifferenceIcon = dynamic(
  () => import('./difference-icon.svg')
) as IconComponent;

export const SelectedDifferenceIcon = dynamic(
  () => import('./selected-difference-icon.svg')
) as IconComponent;

export const RemoveDiffItem = dynamic(
  () => import('./remove-diff-item.svg')
) as IconComponent;

export const NoItemDiffList = dynamic(
  () => import('./no-item-diff-list.svg')
) as IconComponent;

export const VideoIcon = dynamic(() => import('./videoIcon.svg'));
export const CalenderDiffIcon = dynamic(
  () => import('./calender-diff-icon.svg')
) as IconComponent;

export const CloseWithCircleWhite = dynamic(
  () => import('./close-with-circle-white.svg')
) as IconComponent;

export const DiffEmptyHotelIcon = dynamic(
  () => import('./diff-empty-hotel-icon.svg')
) as IconComponent;

export const UserUnfollow = dynamic(
  () => import('./user-unfollow-line.svg')
) as IconComponent;

export const SettingIcon = dynamic(
  () => import('./setting.svg')
) as IconComponent;

export const ThemeIcon = dynamic(
  () => import('./theme-icon.svg')
) as IconComponent;

export const RestuarantIcon = dynamic(
  () => import('./restaurant-2-line.svg')
) as IconComponent;

export const PoolIcon = dynamic(
  () => import('./pool-icon.svg')
) as IconComponent;

export const KidsIcon = dynamic(
  () => import('./kids-icon.svg')
) as IconComponent;

export const OkeyIcon = dynamic(() => import('./ok-icon.svg')) as IconComponent;

export const SpaIcon = dynamic(
  () => import('./leaf-line.svg')
) as IconComponent;

export const TickIcon = dynamic(
  () => import('./tick-icon.svg')
) as IconComponent;

export const NoFeatureIcon = dynamic(
  () => import('./exit-icon.svg')
) as IconComponent;

export const LineIcon = dynamic(
  () => import('./subtract-line.svg')
) as IconComponent;

export const CancellationGuarantryIcon = dynamic(
  () => import('./cancellation-guaranty-icon.svg')
) as IconComponent;

export const FilterSearchIcon = dynamic(
  () => import('./search-line.svg')
) as IconComponent;

export const SmilingStar = dynamic(
  () => import('./smiling-star.svg')
) as IconComponent;

export const RegisteredUserIcon = dynamic(
  () => import('./registered-user-icon.svg')
) as IconComponent;

export const ExpediaReviewIcon = dynamic(
  () => import('./expedia-review-icon.svg')
) as IconComponent;

export const ExpediaBusinessIcon = dynamic(
  () => import('./expedia-business.svg')
) as IconComponent;

export const ExpediaFunBusinessIcon = dynamic(
  () => import('./expedia-fun-business.svg')
) as IconComponent;

export const ExpediaFunIcon = dynamic(
  () => import('./expedia-fun.svg')
) as IconComponent;

export const PlanVacationHotel = dynamic(
  () => import('./plan-vacation-hotel.svg')
) as IconComponent;

export const PlanVacationTour = dynamic(
  () => import('./plan-vacation-tour.svg')
) as IconComponent;

export const PlanVacationCruise = dynamic(
  () => import('./plan-vacation-cruise.svg')
) as IconComponent;

export const PlanVacationPackage = dynamic(
  () => import('./plan-vacation-package.svg')
) as IconComponent;

export const PlanVacationFlight = dynamic(
  () => import('./plan-vacation-flight.svg')
) as IconComponent;

export const WorldLogoWhite = dynamic(
  () => import('./world-logo-white.svg')
) as IconComponent;

export const WorldLogoPromotion = dynamic(
  () => import('./world-card-promotion.svg')
) as IconComponent;

export const WorldLogoPromotionBig = dynamic(
  () => import('./world-card-promotion-big.svg')
) as IconComponent;

export const WorldLogoPromotionMedium = dynamic(
  () => import('./world-card-promotion-medium.svg')
) as IconComponent;

export const WarningCircleIcon = dynamic(
  () => import('./warning-icon-circle.svg')
) as IconComponent;

export const SeturExtra = dynamic(
  () => import('./seturExtraImage.svg')
) as IconComponent;

export const SeturLogoSpecial = dynamic(
  () => import('./60.YılSeturLogo.svg')
) as IconComponent;

export const SeturLogoMobile = dynamic(
  () => import('./60.yılLogoResponsive.svg')
) as IconComponent;

export const MemberOpportunityIcon = dynamic(
  () => import('./memberOpportunity-icon.svg')
) as IconComponent;
